import { RewardStep } from '@intigral/shared';

const Badges = ({ badgeProps }) => {
    const { activeBadge, badges, badgeLoading } = badgeProps;

    return <RewardStep activeIndex={activeBadge?.index || 0} rewardBadges={badges} isLoading={badgeLoading} />;
};

export default Badges;
